module.exports = __webpack_public_path__ + "img/describe.2a354ade.svg";